import React, { useState, useEffect } from 'react';
import './VideoGallery.css';

const VideoGallery = () => {
  const videos = [
    { title: 'Video Gallery', src: 'video2.mp4', caption: 'A brief overview of the Commonwealth AI Academy' },
    { title: 'Video Gallery', src: 'video1.mp4', caption: 'Secretary General\'s AI Legacy for the Commonwealth' },
    { title: 'Video Gallery', src: 'video3.mp4', caption: 'A brief about the Commonwealth Artificial Intelligence Consortium' },
    { title: 'Video Gallery', src: 'video4.mp4', caption: 'Interview with Dr. Radika Kumar on the sideline of Youth Day 2024' },
    { title: 'Video Gallery', src: 'video6.mp4', caption: 'The Revolution of AI in the Commonwealth' },
    { title: 'Video Gallery', src: 'video5.mp4', caption: 'A Commonwealth Legacy with Open Weaver' },
    // Add more videos as needed
  ];

  const [currentIndex, setCurrentIndex] = useState(1);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? videos.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === videos.length - 1 ? 0 : prevIndex + 1));
  };

  const renderVideos = () => {
    const prevIndex = (currentIndex - 1 + videos.length) % videos.length;
    const nextIndex = (currentIndex + 1) % videos.length;

    if (isMobile) {
      return (
        <div className="video-item video-center">
          <video controls key={`video-${currentIndex}`} className="main-video">
            <source src={videos[currentIndex].src} type="video/mp4" />
          </video>
          <p className="video-caption">{videos[currentIndex].caption}</p>
        </div>
      );
    }

    return (
      <>
        <div className="video-item video-left">
          <video key={`video-${prevIndex}`}>
            <source src={videos[prevIndex].src} type="video/mp4" />
          </video>
        </div>
        <div className="video-item video-center">
          <video controls key={`video-${currentIndex}`} className="main-video">
            <source src={videos[currentIndex].src} type="video/mp4" />
          </video>
          <p className="video-caption">{videos[currentIndex].caption}</p>
        </div>
        <div className="video-item video-right">
          <video key={`video-${nextIndex}`}>
            <source src={videos[nextIndex].src} type="video/mp4" />
          </video>
        </div>
      </>
    );
  };

  return (
    <div className="video-gallery">
      <div className="video-gallery-content">
        <h2 className="video-title">{videos[currentIndex].title}</h2>
        <div className="video-container">{renderVideos()}</div>
        <div className="controls">
          <button className="arrow left-arrow" onClick={handlePrev}>&#9664; Previous</button>
          <button className="arrow right-arrow" onClick={handleNext}>Next &#9654;</button>
        </div>
      </div>
    </div>
  );
};

export default VideoGallery;
